import { defineMessages } from 'react-intl';

const messages = defineMessages({
  thirtyPercent: {
    description: 'insurance.30Percent',
    defaultMessage: '30% of Order',
    id: 'OAa/L6',
  },
  orderCost: {
    description: 'insurance.orderCost',
    defaultMessage: 'Order cost, minus shipping',
    id: 'qSt/NI',
  },
  sum: {
    description: 'insurance.sum',
    defaultMessage: 'Sum of all Products',
    id: 'PXoFTQ',
  },
  custom: {
    description: 'insurance.custom',
    defaultMessage: 'Custom',
    id: '0QV2uS',
  },
});

export const InsuranceValues = Object.freeze({
  ThirtyPercent: {
    name: 'ThirtyPercent',
    message: messages.thirtyPercent,
  },
  OrderCost: {
    name: 'OrderCost',
    message: messages.orderCost,
  },
  Sum: {
    name: 'Sum',
    message: messages.sum,
  },
  Custom: {
    name: 'Custom',
    message: messages.custom,
  },
});
